import ClusterRecommendations from '@/components/feature/ClusterRecommendations';

export default function ReadNextSection() {
  return <ClusterRecommendations cluster="sales" currentPage="/prodazhi-i-peregovory/trening-po-telefonnym-prodazham" />;
}